import './Theme.Page.Split.scss';
export default `ThemePageSplit`;
